<template>
    <div class="notification-popups-list notification-popups-list--top" v-if="topNotifications.length">
        <TransitionGroup name="collapse">
            <div class="notification-popups-list__item" v-for="notification in topNotifications" :key="notification.id">
                <NotificationPopup v-bind="notification" @destroy-popup="emit('destroyPopup', notification.id)" />
            </div>
        </TransitionGroup>
    </div>
    <div class="notification-popups-list notification-popups-list--bottom" v-if="bottomNotifications.length">
        <TransitionGroup name="collapse">
            <div
                class="notification-popups-list__item"
                v-for="notification in bottomNotifications"
                :key="notification.id"
            >
                <NotificationPopup v-bind="notification" @destroy-popup="emit('destroyPopup', notification.id)" />
            </div>
        </TransitionGroup>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import NotificationPopup from "./notification-popup.vue";
import NotificationPopupProps from "./notification-popup-props";

const emit = defineEmits<{
    destroyPopup: [notificationId: number];
}>();

const props = defineProps<{ notifications: NotificationPopupProps[] }>();

const topNotifications = computed(() =>
    props.notifications.filter((notification) => !notification.position || notification.position == "top").slice(0, 3)
);

const bottomNotifications = computed(() =>
    props.notifications.filter((notification) => notification.position == "bottom").slice(0, 3)
);
</script>
